// Static service catalogue. Kept in sync with the backend seed so SSR/prerender
// has the content synchronously. Sourced from GET /api/services on 2026-02-19.
export const SERVICES = [
  {
    slug: "private-limited",
    title: "Private Limited Registration",
    short: "Best-fit structure for scaling startups and raising capital.",
    icon: "Building2",
    description:
      "A Private Limited Company is the most preferred structure for founders looking to raise investment, hire teams, and scale.",
    inclusions: [
      "Name reservation (RUN) & DIN allotment",
      "Digital Signature (DSC) for 2 directors",
      "MOA & AOA drafting",
      "Certificate of Incorporation",
      "PAN, TAN & bank account letter",
      "First board resolution & compliance kit",
    ],
    required_docs: [
      "PAN + Aadhaar of directors",
      "Passport-size photo",
      "Address proof (bank/utility)",
      "Registered office proof (rent agreement / NOC)",
    ],
    timeline: "7 to 12 working days",
  },
  {
    slug: "llp",
    title: "LLP Registration",
    short: "Lean partnership structure with limited liability.",
    icon: "Handshake",
    description:
      "Limited Liability Partnerships suit consultancy, agency and professional firms wanting flexibility without a PVT. LTD.'s compliance load.",
    inclusions: [
      "Name approval",
      "DPIN & DSC",
      "LLP Agreement drafting",
      "Certificate of Incorporation",
      "PAN & TAN",
    ],
    required_docs: [
      "PAN + Aadhaar of partners",
      "Address proof",
      "Registered office proof",
    ],
    timeline: "8 to 14 working days",
  },
  {
    slug: "opc",
    title: "OPC Registration",
    short: "Solo founder? Get corporate identity with One Person Company.",
    icon: "User",
    description:
      "One Person Company gives solo founders limited liability and separate legal identity a great first step before opening up to co-founders.",
    inclusions: [
      "Name reservation",
      "DIN & DSC",
      "MOA & AOA",
      "Certificate of Incorporation",
      "Nominee declaration",
    ],
    required_docs: [
      "PAN + Aadhaar",
      "Nominee KYC",
      "Registered office proof",
    ],
    timeline: "7 to 12 working days",
  },
  {
    slug: "startup-india-dpiit",
    title: "Startup India / DPIIT Support",
    short: "Get recognized. Unlock tax exemptions and government schemes.",
    icon: "Rocket",
    description:
      "We prepare and file your DPIIT recognition end-to-end pitch note, innovation summary and scheme mapping to unlock 80-IAC tax exemption, IPR fast-track, and public-tender eligibility.",
    inclusions: [
      "DPIIT application filing",
      "Innovation & scalability writeup",
      "Section 80-IAC guidance",
      "Certificate follow-up",
    ],
    required_docs: [
      "Certificate of Incorporation",
      "Founder details",
      "Business/product summary",
      "Website or pitch deck",
    ],
    timeline: "15 to 30 working days",
  },
  {
    slug: "gst-msme-compliance",
    title: "GST / MSME / Compliance",
    short: "Stay compliant from day one the boring part done right.",
    icon: "ShieldCheck",
    description:
      "From GST registration and Udyam (MSME) to ROC annual filings and ITR we handle the compliance calendar so you can focus on building.",
    inclusions: [
      "GST registration",
      "Udyam / MSME certificate",
      "ROC annual filings",
      "Income tax filings",
      "Compliance calendar",
    ],
    required_docs: [
      "Certificate of Incorporation / firm proof",
      "PAN",
      "Bank details",
      "Business address proof",
    ],
    timeline: "3 to 10 working days per module",
  },
  {
    slug: "business-presence",
    title: "Business Presence Setup",
    short: "Domain, email, website & brand basics ready to launch.",
    icon: "Globe",
    description:
      "Every founder needs a credible online presence before pitching customers or investors. We set up domain, professional Google Workspace email, a starter website and brand starter kit.",
    inclusions: [
      "Domain + Workspace email",
      "One-page launch website",
      "Basic brand kit (logo/colour tokens)",
      "Google Business profile",
    ],
    required_docs: [
      "Business name/logo idea",
      "Basic content brief",
    ],
    timeline: "5 to 10 working days",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug) || null;
